import { ModelBase } from 'store/model-base';

export class CmsLevelMoveInProgress extends ModelBase {
    public static storeName: string = 'cmsLevelMoveInProgress';

    public header: string;
    public subhead: string;
    public pageTitle: string;
    public icon: CmsMediaImage;
}
